import { render, staticRenderFns } from "./settlementMethod.vue?vue&type=template&id=3844e37e&scoped=true"
import script from "./settlementMethod.vue?vue&type=script&lang=js"
export * from "./settlementMethod.vue?vue&type=script&lang=js"
import style0 from "./settlementMethod.vue?vue&type=style&index=0&id=3844e37e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3844e37e",
  null
  
)

export default component.exports